enum LookerReportType {
  Total = 'TOTAL',

  DateDelivery = 'DATE_DELIVERY',
  WeekDelivery = 'WEEK_DELIVERY',
  MonthDelivery = 'MONTH_DELIVERY',
  QuarterDelivery = 'QUARTER_DELIVERY',
  ChannelDelivery = 'CHANNEL_DELIVERY',
  DeviceDelivery = 'DEVICE_DELIVERY',
  CampaignDelivery = 'CAMPAIGN_DELIVERY',
  AdvertiserDelivery = 'ADVERTISER_DELIVERY',
  PlacementDelivery = 'PLACEMENT_DELIVERY',
  CreativeDelivery = 'CREATIVE_DELIVERY',
  PublisherDelivery = 'PUBLISHER_DELIVERY',
  DayOfWeekDelivery = 'DAYS_OF_WEEK_DELIVERY',
  DaypartDelivery = 'DAYPART_DELIVERY',
  DealsDelivery = 'DEALS_DELIVERY',
  DmaDelivery = 'DMA_DELIVERY',
  CityDelivery = 'CITY_DELIVERY',
  StateDelivery = 'STATE_DELIVERY',
  CountyDelivery = 'COUNTY_DELIVERY',
  CongressionalDistrictDelivery = 'CONGRESSIONAL_DISTRICT_DELIVERY',
  ZipDelivery = 'ZIP_DELIVERY',

  DateAttribution = 'DATE_ATTRIBUTION',
  WeekAttribution = 'WEEK_ATTRIBUTION',
  MonthAttribution = 'MONTH_ATTRIBUTION',
  QuarterAttribution = 'QUARTER_ATTRIBUTION',
  ChannelAttribution = 'CHANNEL_ATTRIBUTION',
  DeviceAttribution = 'DEVICE_ATTRIBUTION',
  CampaignAttribution = 'CAMPAIGN_ATTRIBUTION',
  AdvertiserAttribution = 'ADVERTISER_ATTRIBUTION',
  PlacementAttribution = 'PLACEMENT_ATTRIBUTION',
  CreativeAttribution = 'CREATIVE_ATTRIBUTION',
  PublisherAttribution = 'PUBLISHER_ATTRIBUTION',
  DayOfWeekAttribution = 'DAYS_OF_WEEK_ATTRIBUTION',
  DaypartAttribution = 'DAYPART_ATTRIBUTION',
  DealsAttribution = 'DEALS_ATTRIBUTION',
  DmaAttribution = 'DMA_ATTRIBUTION',
  CityAttribution = 'CITY_ATTRIBUTION',
  StateAttribution = 'STATE_ATTRIBUTION',
  CountyAttribution = 'COUNTY_ATTRIBUTION',
  CongressionalDistrictAttribution = 'CONGRESSIONAL_DISTRICT_ATTRIBUTION',
  ZipAttribution = 'ZIP_ATTRIBUTION',

  Pacing = 'PACING',

  DateWebVisits = 'DATE_WEB_VISITS',
  DigitalChannelWebVisits = 'DIGITAL_CHANNEL_WEB_VISITS',
  DeviceWebVisits = 'DEVICE_WEB_VISITS',
  CampaignWebVisits = 'CAMPAIGN_WEB_VISITS',
  PixelWebVisits = 'PIXEL_WEB_VISITS',
  PlacementWebVisits = 'PLACEMENT_WEB_VISITS',
  CreativeWebVisits = 'CREATIVE_WEB_VISITS',
  PublisherWebVisits = 'PUBLISHER_WEB_VISITS',
  DayOfWeekWebVisits = 'DAYS_OF_WEEK_WEB_VISITS',
  DaypartWebVisits = 'DAYPART_WEB_VISITS',
  StateWebVisits = 'STATE_WEB_VISITS',
  CountyWebVisits = 'COUNTY_WEB_VISITS',
  ZipWebVisits = 'ZIP_WEB_VISITS',
  CongressionalDistrictWebVisits = 'CONGRESSIONAL_DISTRICT_WEB_VISITS',
  DmaWebVisits = 'DMA_WEB_VISITS',
  CityWebVisits = 'CITY_WEB_VISITS',

  //#region pixels
  EventFiresPreview = 'PIXELS_EVENT_FIRES_PREVIEW',
  EventFiresByDay = 'PIXELS_EVENT_FIRES_BY_DAY',
  //#endregion
}

export default LookerReportType;
